"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupService = void 0;
const axios_1 = __importDefault(require("axios"));
const environment_1 = require("../../constants/environment");
const environment_enum_1 = require("../enum/environment.enum");
class GroupService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key) {
        this.RESOURCE = 'group';
        this.getClientsOrMemberships = async (params, abort) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/admin/clients-membership`;
            const path = !!params ? `${URL}?${this.objectToQueryString(params)}` : URL;
            const response = await axios_1.default.get(path, { headers: { 'x-api-key': this.KEY }, signal: abort ? abort.signal : null });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getGroups = async (params, abort) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/admin`;
            const path = !!params ? `${URL}?${this.objectToQueryString(params)}` : URL;
            const response = await axios_1.default.get(path, { headers: { 'x-api-key': this.KEY }, signal: abort ? abort.signal : null });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getUsersForAdmin = async (body, abort) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/admin/user`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY }, signal: abort ? abort.signal : null });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getTags = async (abort) => {
            const path = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/admin/tag`;
            const response = await axios_1.default.get(path, { headers: { 'x-api-key': this.KEY }, signal: abort ? abort.signal : null });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.updateGroupStatus = async (id, body, abort) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/${id}/status`;
            const response = await axios_1.default.put(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY }, signal: abort ? abort.signal : null });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.createGroup = async (body, abort) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY }, signal: abort ? abort.signal : null });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.updateGroup = async (id, body, abort) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/${id}`;
            const response = await axios_1.default.put(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY }, signal: abort ? abort.signal : null });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getGroup = async (id, abort) => {
            const path = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/${id}`;
            const response = await axios_1.default.get(path, { headers: { 'x-api-key': this.KEY }, signal: abort ? abort.signal : null });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.objectToQueryString = (obj) => Object.keys(obj).map(key => {
            const value = obj[key];
            let parameter = `${key}=${value}`;
            if (Array.isArray(value)) {
                let multiValueParams = '';
                const lastIndex = value.length - 1;
                value.forEach((item, index) => multiValueParams += `${key}=${item}${index === lastIndex ? '' : '&'}`);
                return multiValueParams;
            }
            return parameter;
        }).join("&");
        this.ENV = ENV;
        this.KEY = key;
    }
}
exports.GroupService = GroupService;
